import { FC, useEffect } from 'react';
import { useTranslation } from '../translations';
import { useQuery } from '../utils';

export const ExternalOauthLoginComponent: FC = () => {
  const code = useQuery().get('code');

  const { ts } = useTranslation();

  useEffect(() => {
    if (!code) {
      return;
    }

    (window.opener as Window).postMessage({ code }, window.location.origin);
  });

  if (!code) {
    return ts('could_not_find_code_in_the_url_parameters');
  }

  return ts('logging_in');
};
